import { ethers } from "ethers";
import type { StoredJoinSplitNote } from "../../joinsplit/types";
import { selectForAmount } from "../../joinsplit-v2/spendSelection";

/** Only a preview: spend preparation still authenticates notes and reads the
 * current tree before obtaining the final transaction-specific quote. */
export function privateFeePreviewRequest({
  action,
  amount,
  recipient,
  notes,
  token,
  pool,
  decimals,
  chainId,
}: {
  action: "deposit" | "p2p" | "withdraw";
  amount: string;
  recipient: string;
  notes: StoredJoinSplitNote[];
  token: string;
  pool: string;
  decimals: number;
  chainId: number;
}) {
  if (action === "deposit") return { kind: 5 };
  try {
    const gross = ethers.parseUnits(amount, decimals);
    if (gross <= 0n || (action === "withdraw" && !ethers.isAddress(recipient)))
      return null;
    const candidates = notes.filter(
      ({ spent, note }) =>
        !spent &&
        note.protocol === "flat-joinsplit-v2" &&
        note.chainId === chainId &&
        note.poolAddress?.toLowerCase() === pool.toLowerCase() &&
        note.tokenData?.tokenAddress.toLowerCase() === token.toLowerCase() &&
        Number.isInteger(note.treeIndex) &&
        Number.isInteger(note.leafIndex) &&
        note.leafIndex >= 0,
    );
    const tree = Math.max(...candidates.map((n) => n.note.treeIndex!));
    const unique = [
      ...new Map(
        candidates
          .filter((n) => n.note.treeIndex === tree)
          .map((n) => [n.note.commitment.toLowerCase(), n]),
      ).values(),
    ];
    const inputCount = selectForAmount(unique, gross).length;
    return {
      kind: action === "p2p" ? 0 : 1,
      inputCount,
      grossAmount: gross.toString(),
      recipient:
        action === "p2p" ? ethers.ZeroAddress : ethers.getAddress(recipient),
    };
  } catch {
    return null;
  }
}
